import { AlgorithmSourcesFormDataSchema } from './AlgorithmSourcesFormDataSchema';

import { AlgorithmSourcesMutationDtoSchema } from './AlgorithmSourcesMutationDto';
import { AlgorithmSourcesValidFormDataSchema } from './AlgorithmSourcesValidFormDataSchema';
import {
  AlgorithmSourcesFormDataType,
  AlgorithmSourcesMutationDtoType,
  AlgorithmSourcesValidFormDataType,
} from './types';

export class AlgorithmSourcesSchema {
  static parseFormData<Dto>(data: Dto): AlgorithmSourcesFormDataType {
    return AlgorithmSourcesFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<AlgorithmSourcesValidFormDataType>
  >(validFormData: ValidFormData): AlgorithmSourcesMutationDtoType {
    return AlgorithmSourcesMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = AlgorithmSourcesValidFormDataSchema;
}
